/**
 * Loading indicator in the game's own language: three little blocks taking
 * turns to hop. Under reduced motion they sit still (the label still says
 * what is happening).
 */
import './ui.css';

export interface SpinnerProps {
  size?: 'small' | 'large';
  /** Visible label; when absent the spinner is decorative (the caller announces the state). */
  label?: string;
}

export function Spinner({ size = 'large', label }: SpinnerProps) {
  return (
    <span className={`ui-spinner ui-spinner--${size}`} role={label ? 'status' : undefined}>
      <span className="ui-spinner__blocks" aria-hidden="true">
        <span />
        <span />
        <span />
      </span>
      {label && <span className="ui-spinner__label">{label}</span>}
    </span>
  );
}
